var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0537 2.60745H5.79633L6.40447 1.08749C6.53383 0.763142 6.43921 0.39227 6.17204 0.173128C5.90453 -0.0458716 5.52809 -0.0580185 5.24669 0.141908L0.332557 3.63188C0.117292 3.78474 -0.00769165 4.0388 0.000367322 4.30653C0.00839156 4.57408 0.148381 4.81961 0.3724 4.95859L5.51086 8.14886C5.80324 8.33028 6.17712 8.29423 6.43073 8.0601C6.68473 7.82601 6.7582 7.44523 6.61202 7.12948L5.93663 5.66858H13.0537C13.5789 5.66858 14.0062 6.11383 14.0062 6.65078V11.9731C14.0062 12.5101 13.5789 12.9388 13.0537 12.9388H5.17749C4.4749 12.9388 3.90532 13.5212 3.90532 14.2396V14.6992C3.90532 15.4177 4.4749 16 5.17749 16H13.0537C15.2297 16 17 14.1981 17 11.9731V6.65081C17.0001 4.42576 15.2297 2.60745 13.0537 2.60745Z",
    fill: "#1B1B1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackLeft);
export default __webpack_public_path__ + "static/media/BackLeft.ac9a7c4ff82ad4e89b9a12c17ce950d9.svg";
export { ForwardRef as ReactComponent };